import http from '@/utils/http';
const base_path = '/v2/tool/douYinAuth';

/**
 * 获取抖音号列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getDouYinAuthApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 同步抖音号接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const pullDouYinAuthApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};
